import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=84144854&scoped=true&"
import script from "./TaskTable.vue?vue&type=script&lang=js&"
export * from "./TaskTable.vue?vue&type=script&lang=js&"
import style0 from "./TaskTable.vue?vue&type=style&index=0&id=84144854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84144854",
  null
  
)

export default component.exports